import { Component } from 'react';
import Table from 'noc/components/table';
import TableHead from 'noc/components/table/head';
import TableHeadRow from 'noc/components/table/head_row';
import TableBodyRow from 'noc/components/table/body_row';
import TableCol from 'noc/components/table/col';
import TableCell from 'noc/components/table/cell';
import TableBody from 'noc/components/table/body';
import classNames from 'classnames';

class GridBody extends Component {
    convertMinToDays(duration) {
        var minutes = parseInt((duration) % 60),
            hours = parseInt((duration / (60)) % 24),
            days = parseInt((duration / (24 * 60)) % (24 * 60));

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        days = (days < 10) ? "0" + days : days;

        return days + "d:" + hours + "h:" + minutes + "m";
    }

    render() {

        const {
            getAllData,
            dataSort,
            printTicket,
            requestForId,
            sortOrders,
            ticketsData,
            tabsData,
            openTicket,
            strSessionId,
            IsSLM,
            OwnerTeamData,
            ticketCheckboxArray,
            IsSLMOwnerTeam
        } = this.props;

        let tabData;
        tabsData.map(tab => {
            if (tab.Id === requestForId) {
                tabData = tab;
            }
        });
        // console.log(OwnerTeamData);
        if (tabData == null || tabData.QueueViewGrid == null) {
            return false;
        }
        // console.log(ticketsData);
        ticketsData.forEach(tickets => {
            tickets.isSelected = ticketCheckboxArray.indexOf(tickets.TicketId) !== -1;
        });

        return (
            <Table>
                <TableHead>
                    <TableHeadRow>
                        {showCheckBox() && IsSLMOwnerTeam == true ? <th className="cn-table__hdr hdr-checkbox--colwidth" /> : null}
                        {tabData
                            .QueueViewGrid
                            .Columns
                            .map((header, i) => {
                                if (header.Name === 'OwnerTeamName') {
                                    if (IsSLM === false) { return false; }
                                }
                                if (header.Name === 'cellName') {
                                    if (IsSLMOwnerTeam === false) { return false; }
                                }
                                if (header.Name === 'MessageCount') {
                                    if (IsSLMOwnerTeam === false) { return false; }
                                }

                                if (!header.IsVisible) { return false; }
                                return (<TableCol
                                    key={i}
                                    isSort={header.IsSort}
                                    name={header.Name}
                                    dataSort={dataSort}
                                    sortOrders={sortOrders}
                                    tabData={tabData}
                                >{header.DisplayName}
                                </TableCol>);
                            })}
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    <tr id="gridgridrectop" key={0} >
                        <td colSpan="200" />
                    </tr>
                    {ticketsData.map((tickets, Id) => {

                        const className = classNames({
                            'cn-table__row': true,
                            'ttd-ticket-warning': tickets.ThresholdStatus === 'Warning',
                            'ttd-ticket-escalation': tickets.ThresholdStatus === 'Escalate',
                            'ttd-ticket-notification': tickets.ThresholdStatus === 'Notification'
                        });

                        const previewTicketClassName = 'noc-table__item-ticket';
                        return (
                            <TableBodyRow
                                key={Id} className={className}
                            >

							

                                {showCheckBox() && IsSLMOwnerTeam == true ?
                                   <TableCell>
                                       <label className="css-checkbox">
                                           <input
                                               type="checkbox"
                                               id="isChecked"
                                               checked={tickets.isSelected}
                                               value={tickets.TicketId}
                                               onChange={e => { getAllData(e.target.checked, e.target.value); }}
                                           />
                                           <label>
                                               <span />
                                           </label>
                                       </label>
                                   </TableCell> : null
                                   } 


                                {tabData.QueueViewGrid.Columns.map((header, i) => {
                                    const value = tickets[header.Name];
                                    if (!header.IsVisible) { return false; }

                                    switch (header.Name) {
                                        case 'MSP':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'TicketId':
                                            return (
                                                <TableCell key={i} className={previewTicketClassName} title={value}>
                                                    <a
                                                        href="#" className="cn-table__link--primary"
                                                        onClick={evt => { evt.preventDefault(); printTicket(value) }}
                                                    > {value} </a>
                                                </TableCell>
                                            );
                                        case 'TicketParameter':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'ThresholdStatus':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'BreachCount_Up':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">
                                                        {!value || value === ''
                                                            ? '\u2014' :
                                                            tabData.Name != 5 ? this.convertMinToDays(value) : value}</span>
                                                </TableCell>
                                            );
                                        case 'ParametersBreach':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'Priority':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'Status':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'Family':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'OwnerTeamName':
                                            if (IsSLM === false) { return false; }
                                            return (
                                                <TableCell key={i} title={value} >
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'cellName':
                                            if (IsSLMOwnerTeam === false) { return false; }
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        case 'AssignedTo':
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? '\u2014' : value}</span>
                                                </TableCell>
                                            );
                                        {/* case 'MessageCount':
                                            if (IsSLMOwnerTeam === false) { return false; }
                                            return (
                                                <TableCell key={i} title={value}>
                                                    <span className="cn-table__data-wrap">{!value || value === ''
                                                        ? 0 : value}</span>
                                                </TableCell>
                                            ); */}
                                        default:
                                            return (
                                                <TableCell key={i} title={value}>{!value || value === ''
                                                    ? '\u2014' : value}
                                                </TableCell>
                                            );
                                    }
                                })
                                }
                            </TableBodyRow>);
                    })
                    }
                    <tr id="gridgridrecbottom" key={this.props.ticketsData.length} >
                        <td colSpan="200" />
                    </tr>
                </TableBody>
            </Table>);
    }
}

export default GridBody;



// WEBPACK FOOTER //
// ./app/tickets/components/GridBody.jsx